<form class="card" [formGroup]="form" novalidate (ngSubmit)="runSave()">
    <div class="card-header clr-justify-content-between clr-align-items-center" style="display: flex">
        <div>Reset Application Cache</div>
        <button type="submit" class="btn btn-info-outline btn-sm m-0" [clrLoading]="loading">
            <clr-icon shape="sync"></clr-icon>
            Reset
        </button>
    </div>
    <div class="card-block">
        <div class="clr-row mb-1">
            <div class="clr-col-lg-5 clr-col">
                Application Configuration:
                <a role="tooltip" aria-haspopup="true" class="tooltip tooltip-right">
                    <clr-icon shape="info-circle" size="24"></clr-icon>
                    <span class="tooltip-content">
                        Clears cached application configuration settings to ensure the latest configurations are applied
                    </span>
                </a>
            </div>
            <div class="clr-col">
                <adm-checkbox-button formControlName="config"></adm-checkbox-button>
            </div>
        </div>
        <div class="clr-row mb-1">
            <div class="clr-col-lg-5 clr-col">
                Database:
                <a role="tooltip" aria-haspopup="true" class="tooltip tooltip-right">
                    <clr-icon shape="info-circle" size="24"></clr-icon>
                    <span class="tooltip-content">
                        Removes cached database data, including records and queries, so the application fetches up-to-date information directly from the database
                    </span>
                </a>
            </div>
            <div class="clr-col">
                <adm-checkbox-button formControlName="db"></adm-checkbox-button>
            </div>
        </div>
        <div class="clr-row mb-1">
            <div class="clr-col-lg-5 clr-col">
                User Sessions with Permissions:
                <a role="tooltip" aria-haspopup="true" class="tooltip tooltip-right">
                    <clr-icon shape="info-circle" size="24"></clr-icon>
                    <span class="tooltip-content">
                        Clears cached permissions and active user sessions. Users won`t be signed out
                    </span>
                </a>
            </div>
            <div class="clr-col">
                <adm-checkbox-button formControlName="auth"></adm-checkbox-button>
            </div>
        </div>
        <div class="clr-row mb-1">
            <div class="clr-col-lg-5 clr-col">
                Search Engine:
                <a role="tooltip" aria-haspopup="true" class="tooltip tooltip-right">
                    <clr-icon shape="info-circle" size="24"></clr-icon>
                    <span class="tooltip-content">
                        Clears cached search results such as users lists, regions, and product searches, ensuring fresh results are generated on the next search
                    </span>
                </a>
            </div>
            <div class="clr-col">
                <adm-checkbox-button formControlName="search"></adm-checkbox-button>
            </div>
        </div>
    </div>
</form>
